
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        filled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            opened: false,
        }
    },
    watch: {
        value: {
            handler(value) {
                this.opened = value;
            },
            immediate: true
        }
    },
    methods: {
        toggle() {
            this.$emit('input', !this.opened);
            this.opened = !this.opened;
        },
        open() {
            this.opened = true
        },
        hide() {
            this.opened = false
        }
    }
}
